import { createAction } from "redux-act";

// -----------------FundRecommend Condition -----------
export const REQFundRecCodiList = createAction("REQUEST_FUNDRECCODI_LIST");
export const RESFundRecCodiList = createAction("RECEIVE_FUNDRECCODI_LIST");
export const FailFundRecCodiList = createAction("FAILED_FUNDRECCODI_LIST");
export const CleanUpFundRecCodiList = createAction("CLEANUP_FUNDRECCODI_LIST");